
import type { PropType } from 'vue'

import { defineComponent, computed } from 'vue'

import DwMarkerState from '@/modules/DispatcherWorkplaceModule/components/DwRecordMarker/State.vue'

import {
    DELIVERY_MARKER_COLOR,
    UNDELIVERED_DELIVERY_MARKER_COLOR,
    TAKE_MARKER_COLOR,
    UNASSIGNED_TAKE_MARKER_COLOR
} from '@/modules/DispatcherWorkplaceModule/constants'

export default defineComponent({
    components: {
        'dw-marker-state': DwMarkerState
    },
    props: {
        type: {
            type: Number,
            default: 1
        },
        state: {
            type: Number,
            default: 0
        },
        orderNumber: {
            type: String,
            default: '1234567'
        },
        timeSlot: {
            type: String,
            default: '10:00'
        },
        waitListStatus: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
        delaying: {
            type: Boolean,
            default: false,
        },
        notAssigned: {
            type: Boolean,
            default: false,
        },
        notDelivered: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const computedColor = computed(() => {
            if (props.type === 1) {
                if (props.notAssigned) {
                    return UNASSIGNED_TAKE_MARKER_COLOR
                }
                
                return TAKE_MARKER_COLOR
            }

            if (props.type === 2) {
                if (props.notDelivered) {
                    return UNDELIVERED_DELIVERY_MARKER_COLOR
                }

                return DELIVERY_MARKER_COLOR
            }

            return 'black'
        })

        return {
            computedColor
        }
    }
})
